import React from 'react';

export default function AdminConsole() {
  return (
    <div className="manage-subs-admin-console">
      Component content: manage-subs/AdminConsole
    </div>
  );
};
